import { render, staticRenderFns } from "./WhitelistRuleConfig.vue?vue&type=template&id=07a28814&scoped=true"
import script from "./WhitelistRuleConfig.vue?vue&type=script&lang=js"
export * from "./WhitelistRuleConfig.vue?vue&type=script&lang=js"
import style0 from "./WhitelistRuleConfig.vue?vue&type=style&index=0&id=07a28814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a28814",
  null
  
)

export default component.exports